<template>
    <div class=" container containerBox">
        <cmp-lessee-form :itemData="{}"></cmp-lessee-form>
    </div>
</template>

<script>
import CmpLesseeForm from "../CmpLesseeForm/CmpLesseeForm";
export default {
    name: "AddHousehold",
    components: {
        CmpLesseeForm
    },
    created() {
        
    }
};
</script>
<style>
.select-residence-box .el-select {
    width: 104px;
}
</style>

<style scoped>
.add-household-container {
    padding: 20px 10px;
    background: #fff;
}
</style>
